import { expected } from '@aloft/toolkit-shared';
import { Block, Icon, theme } from '@aloft/toolkit-sui';

import { resolveFeatureGridFieldConflicts } from '../../../../redux/features/actions/resolveFeatureGridFieldConflicts.ts';
import { useAppDispatch } from '../../../../redux/hooks.ts';
import { PropertyGridFieldName } from '../../types.ts';

type ConflictResolveButtonProps = {
  show: boolean;
  propertyDataFieldName: string;
  conflictedFields: Record<string, { fieldName: PropertyGridFieldName; propertyId: string }>;
};

export const ConflictResolveButton = ({
  show,
  propertyDataFieldName,
  conflictedFields,
}: ConflictResolveButtonProps) => {
  const dispatch = useAppDispatch();

  if (!show) return null;

  return (
    <Block
      title="This field has a conflict with another data source."
      width="20px"
      height="20px"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        dispatch(
          resolveFeatureGridFieldConflicts({
            [propertyDataFieldName]: expected(conflictedFields[propertyDataFieldName]),
          }),
        );
      }}
      __dangerDoNotUseSx={{
        backgroundColor: theme.colors.alertSuccess,
        border: `1px solid ${theme.colors.textSuccess}`,
      }}
    >
      <Icon icon="check" color="textOffset" size="md" />
    </Block>
  );
};
